import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import configureStore from "./configure-store";

import App from "./components/MenuBar";

const ComplexMenuBar = (props) => {
  const store = configureStore(props);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <App {...props} />
      </BrowserRouter>
    </Provider>
  );
};

export default ComplexMenuBar;
